export const getData = (state) => state.deviceImports.data;
export const getErrors = (state) => state.deviceImports.errors;
export const getIsDeleting = (state) => state.deviceImport.isDeleting;
export const getIsFetching = (state) => state.deviceImports.isFetching;
export const getModalOpen = (state) => state.deviceImport.modalOpen;
export const getOffset = (state) => state.deviceImports.offset;
